import { Route, Routes } from '@angular/router';
import { DomainAllowlistComponent } from './components/domain-allowlist.component';

export const DomainAllowlistRoutes: Routes = [
  {
    path: '',
    children: [
      <Route>{
        path: '',
        component: DomainAllowlistComponent,
      },
    ],
  },
];
